import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useMyContext } from "../../store/ContextApi";
import { api_auth } from "../../services/api_config";

const OAuth2RedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setToken, setIsAdmin } = useMyContext();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');

    if (code) {
      api_auth.post(`/auth/public/exchange-code?code=${code}`)
        .then((response) => {
          const { jwtToken, roles } = response.data;
          const decodedToken = jwtDecode(jwtToken);

          const user = {
            username: decodedToken.sub,
            roles: roles || [],
          };
          localStorage.setItem('USER', JSON.stringify(user));

          setToken(jwtToken);
          setIsAdmin(user.roles.includes('ROLE_ADMIN'));

          setTimeout(() => {
            navigate('/');
          }, 100);
        })
        .catch((error) => {
          console.error('Code exchange failed:', error);
          navigate('/login');
        });
    } else {
      navigate('/login');
    }
  }, [location, navigate, setToken, setIsAdmin]);

  return <div>Redirecting...</div>;
};

export default OAuth2RedirectHandler;
